import { ReactComponent as ViewIconFile } from 'assets/icons/view-file-icon.svg'

import { IconStyles } from '../types'
import { ViewFileIconCustom } from './styles'

interface ViewFileProps extends IconStyles {
  onClick?: any
  width?: string
  height?: string
  filter?: boolean
  disabled?: boolean
}

const ViewFileIcon = ({
  onClick,
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  disabled,
  height,
  width,
  filter = false
}: ViewFileProps) => {
  return (
    <ViewFileIconCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={disabled ? null : onClick}
      colorIcon={colorIcon}
      width={width}
      height={height}
      filter={filter}
    >
      <ViewIconFile />
    </ViewFileIconCustom>
  )
}

export default ViewFileIcon
